(function () {
  var storageKey = 'zjWishlist';

  function readWishlist() {
    try {
      var value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(value) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {}
  }

  function initWishlistButton(button) {
    if (button.dataset.wishlistInitialized) return;
    button.dataset.wishlistInitialized = 'true';

    var handle = button.dataset.productHandle;
    var title = button.dataset.productTitle;
    var update = function (selected) {
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-label', (selected ? 'Remove ' : 'Add ') + title + (selected ? ' from wishlist' : ' to wishlist'));
    };

    update(readWishlist().indexOf(handle) !== -1);
    button.addEventListener('click', function () {
      var wishlist = readWishlist();
      var index = wishlist.indexOf(handle);
      if (index === -1) wishlist.push(handle);
      else wishlist.splice(index, 1);
      saveWishlist(wishlist);
      update(index === -1);
    });
  }

  function initWishlist() {
    document.querySelectorAll('.zj-product-page .zj-product-wishlist').forEach(initWishlistButton);
  }

  initWishlist();
  document.addEventListener('shopify:section:load', initWishlist);
})();
